module.exports = __webpack_public_path__ + "img/monitor_4.4926c0a7.png";